import api from "../../services/api";

const path = "v1/promocode";

export const getPromocodes = async (params = "") => {
  return await api.get(`${path}${params}`);
};

export const postPromocode = async ({ body }) => {
  return await api.post(`${path}`, body);
};
